// extracted by mini-css-extract-plugin
export default {"root":"dots-loader_root__o3JM9","loader":"dots-loader_loader__JLGTD","placeHolderShimmer":"dots-loader_placeHolderShimmer__Y9Yoi"};